import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';

const OperationButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, ...restProps } = props;
  return <ProButton {...restProps}>{text || children}</ProButton>;
};

export default OperationButton;
